import { Box } from "@mui/material";

export const Test = () => {
  return <Box></Box>;
};
